// extracted by mini-css-extract-plugin
module.exports = {"BankingWrapper":"style-module--BankingWrapper--C7AEu","tas2u":"style-module--tas2u--3BbYO","title":"style-module--title--3q6lh"};